import { inRange, isEmpty, uniq } from 'lodash';

// return only numbers
const validPhone = (phoneNumber) => {

  const regex = /[0-9]/gi;

  if (phoneNumber) {
    phoneNumber = phoneNumber
      .match(regex, '')
      .join('');
  }

  return phoneNumber;
};

const validateLastDigits = (enabled = false, finishedIn = '') => {
  const finishedInParsed = finishedIn.trim().replace(/ /g, '');
  const finishedInLength = finishedIn.length;

  const response = {
    status: true,
    msg: '',
    finishedIn: '',
  };

  if (enabled) {
    if (finishedInLength === 0) {
      response.status = false;
      response.msg = 'field_finishedIn_empty';

      return response;
    } else {
      if (
        (finishedInLength === 1 && !/^\d$/.test(finishedInParsed)) ||
        (finishedInLength > 1 && !/^[0-9](,[0-9])*$/.test(finishedInParsed))
      ) {
        response.status = false;
        response.msg = 'field_finishedIn_only_number';
        response.finishedIn = finishedInParsed;

        return response;
      }

      response.finishedIn = uniq(finishedInParsed.split(',')).join(',');
    }
  }

  return response;
};

const validRange = (value, min, max) => inRange(value, min, max + 1);

module.exports = {
  validPhone,
  validRange,
  validateLastDigits,
};